import { Loop as RefreshButtonIcon } from '@mui/icons-material';

import React from 'react';

import Button from './Button';
import injectStores from '../RootStore/injectStores';
import type { RouterStore } from 'stores/RouterStore';

interface RefreshDataButtonProps {
  routerStore?: RouterStore;
  refreshButtonLoading: boolean;
}

class RefreshDataButton extends React.PureComponent<RefreshDataButtonProps> {
  render() {
    const { routerStore, refreshButtonLoading = false } = this.props;
    const triggerEnterSideEffects = routerStore?.triggerEnterSideEffects;
    const isRunningSideEffects = routerStore?.isRunningSideEffects;

    return (
      <Button
        tooltip={
          refreshButtonLoading && isRunningSideEffects
            ? 'Loading Data'
            : 'Refresh Data'
        }
        color="white"
        justIcon
        loading={refreshButtonLoading ? isRunningSideEffects : false}
        autosize
        onClick={() => triggerEnterSideEffects(true)} // passing true makes sure routerStore knows it's a users manual request
      >
        <RefreshButtonIcon />
      </Button>
    );
  }
}

// RefreshDataButton.defaultProps = {
//   refreshButtonLoading: false,
// };

export default injectStores(RefreshDataButton);
